import { render, staticRenderFns } from "./OrganizationFormTab.vue?vue&type=template&id=b0b622e8&"
import script from "./OrganizationFormTab.vue?vue&type=script&lang=js&"
export * from "./OrganizationFormTab.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationFormTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports